import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function Confirm({
  isOpen = false,
  title = "Alerta",
  text = "",
  onClose,
  onYes,
  onNo,
  cancelTitle = "Cancelar",
  yesTitle = "Si",
  noTitle = "No",
}) {
  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="form-dialog-title"
      >
        {title && <DialogTitle id="form-dialog-title">{title}</DialogTitle>}
        <DialogContent>
          {text && <DialogContentText>{text}</DialogContentText>}
        </DialogContent>
        <DialogActions>
          <Button onClick={onYes} color="primary">
            {yesTitle}
          </Button>
          <Button onClick={onNo} color="secondary">
            {noTitle}
          </Button>
          <Button onClick={onClose}>{cancelTitle}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
